import { useQuery } from '@tanstack/react-query'
import { getUnavailableItemsSummary } from '../../../services/Item/Item.service'
import useUser from '../../Shared/UserProvider/useUser'

const useUnavailableItemSummary = ({ from, to, enabled }) => {
    const {user} = useUser()
    return useQuery({
        queryFn: () => getUnavailableItemsSummary(from, to),
        queryKey: ['pointofsales', user.getUserPos()?.id, 'unavailableItemsSummary', from, to],
        enabled
    })
}

export { useUnavailableItemSummary }
